import { Job, JobFromAPI } from '../types';
import { transformJob } from './api-transforms';
import apiRequest from './apiRequest';

type JobPostPayload = {
  moreVariations: boolean;
  prompt: string;
  selectedAnimationNumber?: number;
  trimStart?: number;
  trimEnd?: number;
  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function postSessionPrompt(
  sessionID: string,
  props: JobPostPayload,
) {
  const { data, error } = await apiRequest<JobFromAPI>(
    'mogen-orchestration',
    `/sessions/${sessionID}/prompt`,
    {
      method: 'POST',
      body: JSON.stringify(props),
    },
  );

  return {
    data: transformJob(data),
    error,
  };
}
